var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.887a1.728 1.728 0 01-.578-.087c-2.547-.875-6.6-3.98-6.6-8.567A4.226 4.226 0 019.035 5 4.149 4.149 0 0112 6.229 4.149 4.149 0 0114.964 5a4.23 4.23 0 014.213 4.233c0 4.594-4.053 7.692-6.6 8.567a1.728 1.728 0 01-.577.087zM9.035 6a3.226 3.226 0 00-3.213 3.233c0 4.56 4.387 7.1 5.929 7.625a1.058 1.058 0 00.5 0c1.536-.527 5.929-3.058 5.929-7.625A3.226 3.226 0 0014.971 6a3.172 3.172 0 00-2.564 1.3.517.517 0 01-.8 0A3.185 3.185 0 009.035 6z",
    fill: "currentColor",
    "data-name": "vuesax/outline/heart"
  })));
}
export default SvgVuesaxOutlineHeart;